// @flow

import type { BankList, PaymentOptionCash } from '@tectonics/prs/incoming-payment/payment-option';

export function getCashBankList(option: PaymentOptionCash): BankList {
  return option.bank_list;
}
